<div class="standard-footer-buttons" [class.single-button]="!showSecondary || hidePrimary">
  <button 
    *ngIf="showSecondary"
    class="btn btn-link secondary-button" 
    [disabled]="isLoading"
    (click)="onSecondaryClick()"
    type="button">
    <span class="text-primary" style="text-decoration: none">
      {{ secondaryLabel }}
    </span>
  </button>

  <button
    *ngIf="!hidePrimary"
    class="btn primary-button"
    [ngClass]="isPrimaryDanger ? 'btn-danger' : 'btn-primary'"
    [disabled]="isPrimaryDisabled || isLoading"
    (click)="onPrimaryClick()"
    type="button">
    <span
      class="spinner-border spinner-border-sm mr-2"
      *ngIf="isLoading"></span>
    <span>{{ primaryLabel }}</span>
  </button>
</div>
